// Token bridge for board-empty (AG overlay + card/kanban host).
import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const boardEmptyStyleId = 'wb-v2-board-empty-theme';

export const boardEmptyBridgeStyles = {
  'board-empty': {
    '--local-board-empty-gap': tokens.spacing.sm,
    '--local-board-empty-padding': tokens.spacing.xl,
    '--local-board-empty-icon-size': '32px',
    '--local-board-empty-icon-color': tokens.color.text.quaternary,
    '--local-board-empty-title-size': tokens.font.size.textMdBase,
    '--local-board-empty-title-weight': tokens.font.weight.medium,
    '--local-board-empty-title-line': tokens.lineHeight.textMd,
    '--local-board-empty-title-color': tokens.color.text.secondary,
    '--local-board-empty-description-size': tokens.font.size.textSm,
    '--local-board-empty-description-line': tokens.lineHeight.textSm,
    '--local-board-empty-description-color': tokens.color.text.tertiary,
  },
};
